<template>
  <div class="app-container member-list">
    <div class="member-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="member-list-filter-value" v-model.trim="search.nickname" @keyup.enter.native="searchChange" placeholder="Birth Name或Full Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="member-list-filter-value" v-model.trim="search.unionId" @keyup.enter.native="searchChange" placeholder="员工号" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <!--
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="member-list-filter-location-value" placeholder="省级地区" v-model="search.province" clearable size="medium">
              <el-option
                v-for="item in search.provinces"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="member-list-filter-location-value" placeholder="市级地区" v-model="search.city" clearable size="medium">
              <template v-if="getCities(search.province)">
                <el-option
                  v-for="item in search.cities"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </template>
            </el-select>
          </div>
        </el-col>
        -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="member-list-filter-value" placeholder="在职/离职" v-model="search.isActive" clearable size="small">
              <el-option
                v-for="item in memberStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select class="member-list-filter-value" placeholder="禁言状态" v-model="search.isBanned" clearable size="small">
              <el-option
                v-for="item in isBannedOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <!-- <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="member-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col> -->
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="member-list-filter-value" v-model.trim="search.organizationalUnitName" @keyup.enter.native="searchChange" placeholder="Organizational Unit Name" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <!-- <div class="grid-content bg-purple">
            <el-select class="member-list-filter-location-value" placeholder="账号等级" v-model="search.tierId" size="small" clearable>
               <el-option
                v-for="item in accountTierOptions"
                :key="item.tierId"
                :label="item.personalName"
                :value="item.tierId">
              </el-option>
            </el-select>
          </div> -->
        </el-col>
        <el-col :span="12">
          <div>
            <el-button class="member-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="member-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="member-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :page="page"
                 :table-loading="listLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">
          <template slot-scope="scope" slot="avatar">
              <div class="admin-image">
                <img class="image" :src="scope.row.avatar">
              </div>
          </template>

          <template slot-scope="scope" slot="phoneNumber">
            <sensitive-data type="phoneNumber" :rawData="scope.row.phoneNumber" :unionId="scope.row.unionId" />
          </template>

        <template slot="menuLeft">
          <el-button
            v-if="permissions.member_export"
            class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>

          <el-button
            v-if="permissions.member_import"
            slot="trigger"
            lass="filter-item"
            size="small"
            type="primary"
            :loading="importLoading"
            @click="handleImport()"
            icon="el-icon-upload2">
            {{importName}}
          </el-button>

          <el-button
            v-if="permissions.member_import"
            class="filter-item"
            size="small"
            type="primary"
            :loading="importTemplateLoading"
            icon="el-icon-download"
            @click="handleImportTemplate()">
            {{importTemplateName}}
          </el-button>
        </template>

        <template slot="totalReward"
                  slot-scope="scope">
                  {{scope.row.totalReward}}
        </template>

        <template slot="postCount"
                  slot-scope="scope">
                  {{scope.row.postCount}}
          <!-- <a href="javascript:void(0);" @click="toPostList(scope.row.memberId);"
              class="member-list-container-button">
            {{scope.row.postCount}}</a> -->
        </template>

        <template slot="columnOpenedCount"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toColumnList(scope.row.memberId);"
              class="member-list-container-button">
            {{scope.row.columnOpenedCount}}</a>
        </template>

        <template slot="commentCount"
                  slot-scope="scope">
            {{scope.row.commentCount}}
        </template>

        <template slot="menu"
                  slot-scope="scope">
          <el-button size="mini"
                    type="text"
                    icon="el-icon-view"
                    @click="handleView(scope.row,scope.index)">查看
          </el-button>
                    <el-button size="mini"
                    type="text"
                    icon="el-icon-edit"
                    v-if="permissions.member_edit"
                    @click="handleEdit(scope.row,scope.index)">编辑
          </el-button>
          <el-button size="mini"
                    type="text"
                    icon="el-icon-warning"
                    v-if="permissions.member_banned && !scope.row.isBanned"
                    @click="handleBanned(scope.row,scope.index)">禁言
          </el-button>
          <el-button size="mini"
                    type="text"
                    icon="el-icon-warning"
                    v-if="permissions.member_unBanned && scope.row.isBanned"
                    @click="handleBanned(scope.row,scope.index)">解禁
          </el-button>
          <!-- <el-button size="mini"
                    type="text"
                    icon="el-icon-close"
                    v-if="permissions.member_inactive && scope.row.isActive"
                    @click="handleActive(scope.row,scope.index)">离职
          </el-button>
          <el-button size="mini"
                    type="text"
                    icon="el-icon-plus"
                    v-if="permissions.member_active && !scope.row.isActive"
                    @click="handleActive(scope.row,scope.index)">在职
          </el-button> -->
          <!-- <el-button size="mini"
                    type="text"
                    icon="el-icon-refresh"
                    @click="handleSync(scope.row,scope.index)">同步
          </el-button> -->
          <!-- <el-button size="mini"
                     type="text"
                     icon="el-icon-delete"
                     v-if="permissions.member_delete && scope.row.isActive"
                     @click="handleDelete(scope.row,scope.index)">删除
          </el-button> -->

        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      title="禁言设置"
      :visible.sync="dialogBannedVisible"
      width="30%">
      <template>
        <el-row>
          <el-col>
            <label class="manual-input-label">是否确认禁言该Birth Name为【{{nickname}}】的员工?</label>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div>
              <el-label class="down-dialog-item-label">禁言截至日期:</el-label>
              <el-date-picker
                  class="member-list-filter-date"
                  type="date"
                  v-model="bannedEndTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="请选择禁言截至日期"
                  size="small">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBannedVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBannedNow()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="upload-dialog"
      title="导入用户列表"
      :visible.sync="importMemberVisible"
      width="30%">
      <template>
        <div>
          <el-upload
            ref="fileUploader"
            class="upload-dialog-input"
            action=""
            accept=".csv,.xls,.xlsx"
            :on-change="handleFileChange"
            :http-request="uploadFile"
            :auto-upload="false">
            <el-button slot="trigger" size="medium" type="primary" plain>选取用户列表文件</el-button>
          </el-upload>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importMemberVisible = false">取 消</el-button>
        <el-button :disabled="importLoading" type="primary" @click="handleImportSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认替换"
      :visible.sync="isCheckDepartureVisible"
      width="30%">
      <p>导入文件中的员工数为 {{importMembersCount}} ，大于上限值{{limitCount}}，是否全部替换、删除不在此文件中的员工数据？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmReplacement">是</el-button>
        <el-button type="primary" @click="cancelReplacement">否</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="deleteTeamTagTipDiaglogTitle"
      :visible.sync="isDeleteTeamTagTipVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="660px"
      custom-class="delete-team-tag-tip-dialog"
    >
      <div class="dialog-content">
        <div class="section">
          <h3 class="section-title">
            <i class="el-icon-warning"></i>
            以下 leader team 标签因无成员已被系统自动删除：
          </h3>
          <div class="item-list">
            <div class="item" v-for="(team, index) in deletedTeamTags" :key="index">
              {{ team }}
            </div>
          </div>
        </div>

        <div class="section">
          <h3 class="section-title">
            <i class="el-icon-warning"></i>
            以下为上述标签相关的未结束培训/课程，请及时检查是否需要调整报名范围：
          </h3>
          <div class="item-list">
            <div class="item" v-for="(course, index) in deletedTeamTagsRelatedAppNames" :key="index">
              {{ course }}
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">
          <i class="el-icon-check"></i> 我已了解
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {addObj, delObj, fetchList, getObj, putObj, getProvinces, getCitiesByProvinceId, updateMemberStatus, exports, syncMemberById, importMembers, fetchMemberImportTemplate, getImportMemberFileData } from '@/api/admin/member'
  import { fetchDepartmentOptions } from '@/api/admin/dept'
  import MemberTypeEnum from '@/common/enums/MemberTypeEnum'
  import { exporting } from '@/util/exportUtil'
  import {tableOption} from '@/const/crud/admin/member'
  import {mapGetters} from "vuex";
  import {constants} from 'fs';
  import {connect} from 'tls';
  import anonymousImage from '@/static/images/member/anonymous.svg';
  import { formatDate as formatDateTime } from '@/util/date';
  import { fetchAccountTierList } from '@/api/admin/tier';
  import SensitiveData from '@/components/sensitive-data';

  const fileTypes = ['xls', 'xlsx', 'csv'];
  const isVaildFileType = (file) => {
    const { name, type } = file.raw;
    return name && fileTypes.includes(name.split('.').pop());
  };

  export default {
    name: "table_member",
    components: {
      SensitiveData,
    },
    data() {
      return {
        memberStatusOptions: [
          {
            label: '在职',
            value: 1
          },
          {
            label: '离职',
            value: 0
          }
        ],
        isBannedOptions: [
          {
            label: '未禁言',
            value: 0
          },
          {
            label: '已禁言',
            value: 1
          }
        ],
        // 搜索功能
        search: {
          current: 1,
          size: 10,
          nickname: "",
          unionId: "",
          preProvince: 0,
          province: "",
          provinces: [],
          city: "",
          cities: [],
          company: "",
          industry: "",
          isActive: 1,
          isBanned: null,
          searchTime: [],
          sortField: "",
          sortPolicy: "",
          departmentOptions: [],
          department: "",
          tierId: null,
          organizationalUnitName: ""
        },
        accountTierOptions: [],
        dialogBannedVisible: false,
        bannedEndTime: '',
        memberId: '',
        nickname: '',
        exportLoading: false,
        exportName: "导出",
        importLoading: false,
        importName: '导入',
        importTemplateLoading: false,
        importTemplateName: '下载导入模板',
        importMemberVisible: false,
        importMemberFile: null,
        // 列表页面
        defaultProps: {
          label: "name",
          value: 'id',
        },
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        menuIds: '',
        list: [],
        tableOption: tableOption,
        listLoading: false,
        form: {},
        isCheckDepartureVisible: false,
        isCheckDeparture: false,
        importMembersCount: '',
        limitCount: '',
        deleteTeamTagTipDiaglogTitle: '',
        isDeleteTeamTagTipVisible: false,
        deletedTeamTags: [],
        deletedTeamTagsRelatedAppNames: []
      };
    },
    activated () {
      this.initPage()
      this.queryMembers()
    },
    async created() {
      await this.initPage()
      await this.loadDepartmentOptions()
      await this.loadAccountTierOptions()
      await this.queryMembers()
      // this.getAllProvinces()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (!record.nickname) { record.nickname = "--" }
            if (!record.avatar) { record.avatar = anonymousImage }
            if (!record.unionId) { record.unionId = "--" }
            if (!record.email) { record.email = "--" }
            if (!record.location) { record.location = "--" }
            if (!record.company) { record.company = "--" }
            if (!record.position) { record.position = "--" }
            if (!record.totalReward) { record.totalReward = 0 }  //总积分
            if (!record.postCount) { record.postCount = 0 }  // 帖子量
            if (!record.commentCount) { record.commentCount = 0 }  // 评论量
            if (!record.circleJoinedCount) { record.circleJoinedCount = 0 }  // 圈子量
            if (!record.followCount) { record.followCount = 0 }  // 关注量
            if (!record.fansCount) { record.fansCount = 0 }  // 粉丝量
            if (!record.grade) { record.grade = "--" }  // 工作岗位
            if (!record.department) { record.department = "--" }  // 所属部门
            if (!record.organizationalUnitName) { record.organizationalUnitName = "--" }
            if (!record.leader) { record.leader = "--" }
            if (!record.staffingModel) { record.staffingModel = "--" }
            if (record.bannedEndTime) { record.bannedEndTime = formatDateTime('YYYY-mm-dd', new Date(record.bannedEndTime))}
            // record.personalTierName = _this.accountTierOptions.find(item => item.tierId === record.tierId).personalName || '--'
          })
        }
        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getList() {
        // 获取会员列表
        let params = {
          current: this.search.current,
          size: this.search.size,
          memberType: MemberTypeEnum.PERSONAL.name
        }
        // 增加搜索功能
        // 昵称
        if (this.search.nickname != "" && this.search.nickname.trim() != "")
          params.nickname = this.search.nickname
        // 员工号
        if (this.search.unionId != "" && this.search.unionId.trim() != "")
          params.unionId = this.search.unionId
        if (this.search.organizationalUnitName != "" && this.search.organizationalUnitName.trim() != "")
          params.organizationalUnitName = this.search.organizationalUnitName
        // 账号等级
        if (this.search.tierId != null)
          params.tierId = this.search.tierId

        // 地区省级市级搜索
        if (this.search.province > 0 && this.search.city == 0) {
          params.isProvince = 1
          params.locationId = this.search.province
        } else if (this.search.province > 0 && this.search.city > 0) {
          params.isProvince = 0
          params.locationId = this.search.city
        }
        if (this.search.isBanned != null)
          params.isBanned = this.search.isBanned
        if (this.search.isActive != null) {
          params.isActive = this.search.isActive
        }
        if (this.search.department != null) {
          params.department = this.search.department
        }

        if (this.startTime && this.endTime) {
          params.registerStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.registerEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.registerStartTime = null
          params.registerEndTime = null
        }

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        else {
          params.sortField = "id"
        }
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = "desc"
        }
        this.listLoading = true
        fetchList(params).then(response => {
          this.list = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.listLoading = false
        });
      },
      getNodeData(data,done) {
        done()
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      getAllProvinces() {
        let _this = this
        getProvinces().then(response => {
          let code = response.status
          let data = response.data
          if (code == 200) {
            _this.search.provinces = []
            if (data.data) {
              data.data.forEach(function(record, index) {
                _this.search.provinces.push({
                  label: record.name,
                  value: record.id
                })
              })
            }
          }
        })
      },
      getCities(provinceId) {
        let _this = this
        if (provinceId == '' || provinceId.length == 0) return false
        if (_this.search.preProvince == provinceId) return true
        getCitiesByProvinceId(provinceId).then(response => {
          let code = response.status
          let data = response.data
          if (code == 200) {
            _this.search.cities = []
            if (data.data) {
              data.data.forEach(function(record, index) {
                _this.search.cities.push({
                  label: record.name,
                  value: record.id
                })
              })
              _this.search.preProvince = provinceId
            }
          }
        })
        return true
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.nickname = ""
        this.search.unionId = ""
        this.search.province = ""
        this.search.city = ""
        this.search.company = ""
        this.search.industry = ""
        this.search.isBanned = null
        this.search.isActive = null
        this.search.searchTime = []
        this.search.department = ""
        this.search.organizationalUnitName = ""
        this.search.tierId = null
        this.searchChange()
      },
      formatDate (date) {
        if (date) {
          return date;
        }
        return null;
      },
      // 页码发生变化
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      // 刷新
      handleRefreshChange() {
        this.getList()
      },
      // 页面展示数据条数发生变化
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getList()
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleSortChange(val) {
        // TODO 检查排序对象
        if (val.prop == "memberId") {
          this.search.sortField = "id"
        } else if (val.prop == "totalReward") {
          this.search.sortField = "total_reward"
        } else if (val.prop == "postCount") {
          this.search.sortField = "post_count"
        } else if (val.prop == "commentCount") {
          this.search.sortField = "comment_count"
        } else if (val.prop == "circleJoinedCount") {
          this.search.sortField = "circle_count"
        } else if (val.prop == "followCount") {
          this.search.sortField = "follow_count"
        } else if (val.prop == "fansCount") {
          this.search.sortField = "follower_count"
        } else if (val.prop == "registerTime") {
          this.search.sortField = "register_time"
        } else if (val.prop == "insertedTime") {
          this.search.sortField = "id"
        } else {
          this.search.sortField = ""
        }
        // 检查排序方式
        if (val.order == 'ascending') {
          this.search.sortPolicy = "asc"
        } else if (val.order == 'descending') {
          this.search.sortPolicy = "desc"
        } else {
          this.search.sortField = "id"
          this.search.sortPolicy = "desc"
        }
        this.getList()
      },
      handleColumnUpdate(row, index){
        this.dialogDetailVisible = false;
        if (row.memberId){
          putObj(row.memberId, row);
        } else {
          this.$message({
            showClose: true,
            message: '该员工不存在',
            type: 'warning'
          })
        }
      },
      handleBanned(row, index){
        this.dialogDetailVisible = false;
        this.nickname = '';
        this.memberId = '';
        this.bannedEndTime = '';
        if (row.memberId){
          if (row.isBanned == false) {
            this.dialogBannedVisible = true;
            this.nickname = row.nickname;
            this.memberId = row.memberId;
          } else {
            this.$confirm('该员工已在禁言状态，是否确认解禁该Birth Name为【' + row.nickname + '】'+ '的员工?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              let params = {
                memberId: row.memberId,
                isBanned: false,
                bannedEndTime: null
              }
              return updateMemberStatus(params);
            }).then(() => {
              this.getList()
              this.$message({
                showClose: true,
                message: '解禁成功',
                type: 'success'
              })
            }).catch(function () {
            })
          }
        }
      },
      handleBannedNow(){
        let params = {
          memberId: this.memberId,
          isBanned: true
        }
        if (!this.bannedEndTime){
           this.$confirm('未选择禁言截至日期，该员工将会被永久禁言', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              return updateMemberStatus(params);
            }).then(() => {
              this.getList()
              this.$message({
                showClose: true,
                message: '禁言成功',
                type: 'success'
              })
              this.dialogBannedVisible = false;
            }).catch(function () {
            })
        }else {
          params.bannedEndTime = this.bannedEndTime;
          updateMemberStatus(params).then(res =>{
              this.getList()
              this.$message({
                showClose: true,
                message: '禁言成功',
                type: 'success'
              })
          })
          .catch(function () {})
          .finally(() => {
            this.dialogBannedVisible = false;
          });
        }

      },
      handleActive(row, index){
        this.dialogDetailVisible = false;
        if (row.memberId){
          if (row.isActive == false) {
            this.$confirm('该员工已是【离职】状态，是否修改该Birth Name为【' + row.nickname + '】'+ '的员工为【在职】状态?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(function () {
              let params = {
                memberId: row.memberId,
                isActive: true
              }
              return updateMemberStatus(params);
            }).then(() => {
              this.getList()
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              })
            }).catch(function () {
            })
          } else {

            this.$confirm('是否修改该Birth Name为【' + row.nickname + '】'+ '的员工为【离职】状态?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
            }).then(function () {
              let params = {
                memberId: row.memberId,
                isActive: false
              }
              return updateMemberStatus(params);
            }).then(() => {
              this.getList()
              this.$message({
                showClose: true,
                message: '修改成功',
                type: 'success'
              })
            }).catch(function () {
            })
          }
        }
      },
      handleSync(row, index) {
          syncMemberById(row.memberId).then(res => {
            if (res.data.code === 0 && res.data.data) {
              this.$message({
                showClose: true,
                message: '同步成功',
                type: 'success'
              })
              this.getList();
            } else {
              this.$message({
                showClose: true,
                message: '同步失败',
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              showClose: true,
              message: '同步失败',
              type: 'error'
            })
          })
      },
      handleView(row, index) {
        this.$router.push({
          path: `/upms/member/detail/${row.memberId}`
        })
      },
      handleEdit(row, index) {
        this.$router.push({
          path: `/upms/member/edit/${row.memberId}`
        })
      },
      handleDelete(row, index) {
        var _this = this
        this.dialogDetailVisible = false;
        this.$confirm('是否确认删除名称为"' + row.nickname + '"'+ '的数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return delObj(row.memberId)
        }).then(() => {
          this.getList()
          this.list.splice(index, 1);
          _this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      filterNode(value, data) {
        if (!value) return true
        return data.label.indexOf(value) !== -1
      },
      toPostList(id) {
        // 会员列表点击一个会员行的帖子数，链接转到会员创建的帖子列表
        this.$router.push({
          path: "/post/posts",
          query: {
            memberId: id
          }
        })
      },
      toArticleList(id) {
        // 会员列表点击一个会员行的文章数，链接转到会员创建的文章列表
        this.$router.push({
          path: "/post/essay",
          query: {
            memberId: id
          }
        })
      },
      toColumnList(id) {
        // TODO 会员列表点击一个会员行的专栏数，链接转到会员创建的专栏列表
        this.$router.push({
          path: "/post/column",
          query: {
            memberId: id
          }
        })
      },
      toCommentList(id) {
        // 会员列表点击一个会员行的评论数，链接转到会员创建的评论列表
        this.$router.push({
          path: "/post/comment",
          query: {
            memberId: id
          }
        })
      },
      handleCircleUpdate(row, index){
        this.dialogDetailVisible = false;
        if (row.memberId){
          putObj(row.memberId, row);
        } else {
          this.$message({
            showClose: true,
            message: '该员工不存在',
            type: 'warning'
          })
        }
      },
      queryMembers() {
        if (this.$route.query.date !== undefined) {
            this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      },
      handleExport() {
        let params = {}
        params.memberType = MemberTypeEnum.PERSONAL.name
        // 增加搜索功能
        if (this.search.nickname != "" && this.search.nickname.trim() != "")
          params.nickname = this.search.nickname
        if (this.search.unionId != "" && this.search.unionId.trim() != "")
          params.unionId = this.search.unionId
        if (this.search.organizationalUnitName != "" && this.search.organizationalUnitName.trim() != "")
          params.organizationalUnitName = this.search.organizationalUnitName

        // 地区省级市级搜索
        if (this.search.province > 0 && this.search.city == 0) {
          params.isProvince = 1
          params.locationId = this.search.province
        } else if (this.search.province > 0 && this.search.city > 0) {
          params.isProvince = 0
          params.locationId = this.search.city
        }
        if (this.search.isBanned != null)
          params.isBanned = this.search.isBanned
        if (this.search.isActive != null) {
          params.isActive = this.search.isActive
        }
        if (this.search.department != null) {
          params.department = this.search.department
        }
        // 账号等级
        if (this.search.tierId != null) {
          params.tierId = this.search.tierId
        }

        if (this.startTime && this.endTime) {
          params.registerStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.registerEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.registerStartTime = null
          params.registerEndTime = null
        }

        // 增加排序功能
        if (this.search.sortField != "" && this.search.sortField.trim() != "")
          params.sortField = this.search.sortField
        if (this.search.sortPolicy != "" && this.search.sortPolicy.trim() != "")
          params.sortPolicy = this.search.sortPolicy

        exports(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
      async handleImport() {
        if (this.$refs.fileUploader) {
          this.$refs.fileUploader.clearFiles();
        }
        this.importMemberVisible = true;
      },
      handleImportSubmit() {
        if (!this.importMemberFile) {
          this.$message.error('请选择用户列表的csv/excel文件');
          return false;
        }
        if (this.importMemberFile.size > 10 * 1024 * 1024) {
          this.$message.error('文件不可以大于 10M');
          return false;
        }

        const formData = new FormData();
        formData.append('file', this.importMemberFile.raw);
        getImportMemberFileData(formData)
          .then((response) => {
            const data = response.data.data;
            this.importMembersCount = data.membersCount;
            this.limitCount = data.departureCheckMemberSize;
            if (data.membersCount > data.departureCheckMemberSize) {
              this.isCheckDepartureVisible = true;
              return;
            }
            this.$refs.fileUploader.submit();
          })
          .catch(err => {
            this.$message.error(err);
          });
      },
      handleFileChange(file, fileList) {
        if (!fileList || fileList.length === 0) {
          return false;
        }

        if (!isVaildFileType(file)) {
          this.$message.error('上传文件只能是csv或excel格式的文件!');
          if (fileList.length > 1) {
            // 当文件数大于1只保留之前的文件
            fileList.splice(1, 1);
          } else {
            // 否则清空控件的所有文件
            this.$refs.fileUploader.clearFiles();
          }
          return false;
        }

        // 当文件数大于 1 时替换之前的文件
        if (fileList.length > 1) {
          fileList.splice(0, 1);
        }

        this.importMemberFile = fileList[0];
      },
      uploadFile({ file }) {
        if (this.isCheckDepartureVisible) return;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('isCheckDeparture', this.isCheckDeparture);

        this.importLoading = true;
        this.importName = '导入中...';
        const fullscreenLoading = this.$loading({
          lock: true,
          text: '用户导入中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)'
        });
        importMembers(formData)
          .then((response) => {
            const data = response.data.data;
            if (data.isAllSuccess) {
              this.$message({
                showClose: true,
                message: '导入成功',
                type: 'success',
              });
            } else {
              window.location = data.notSuccessDataFileUrl;
              this.$message({
                showClose: true,
                message: '部分导入失败，已为您下载未导入成功用户名单',
                type: 'error',
                duration: 5000,
              });
            }

            if (data.isShowDeleteTeamTagTip) {
              this.deleteTeamTagTipDiaglogTitle = data.isAllSuccess ? '导入成功' : '部分导入失败，已为您下载未导入成功用户名单';
              this.isDeleteTeamTagTipVisible = true;
              const allDeletedTeamTags = new Set();
              for (const deletedTeamTags of Object.values(data.appRelatedTagMap)) {
                  deletedTeamTags.forEach(deletedTeamTag => allDeletedTeamTags.add(deletedTeamTag));
              }
              this.deletedTeamTags = Array.from(allDeletedTeamTags);
              this.deletedTeamTagsRelatedAppNames = Object.entries(data.appRelatedTagMap).map(([appName, deletedTeamTags]) => {
                  return `${appName}（${deletedTeamTags.join("、")}）`;
              });
            }
            
            this.importMemberVisible = false;
            this.initPage();
            this.getList();
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.importLoading = false;
            this.importName = '导入';
            fullscreenLoading.close();
          });
      },
      confirmReplacement() {
        this.isCheckDepartureVisible = false;
        this.isCheckDeparture = true;
        this.$refs.fileUploader.submit();
      },
      cancelReplacement() {
        this.isCheckDepartureVisible = false;
        this.isCheckDeparture = false;
        this.$refs.fileUploader.submit();
      },
      handleImportTemplate() {
        this.importTemplateLoading = true;
        fetchMemberImportTemplate()
          .then((response) => {
            if (response && response.data) {
              window.location = response.data.data;
            }
          })
          .catch(err => {
            this.$message.error(err);
          })
          .finally(() => {
            this.importTemplateLoading = false;
          });
      },
      loadDepartmentOptions() {
        fetchDepartmentOptions().then(response => {
          if (response.data && response.data.code === 0 && response.data.data) {
            this.departmentOptions = response.data.data;
            }
        });
      },
      async loadAccountTierOptions() {
        await fetchAccountTierList().then(response => {
          this.accountTierOptions = response.data.data;
        });
      },
      handleClose() {
        this.isDeleteTeamTagTipVisible = false;
        this.deletedTeamTags = [];
        this.deletedTeamTagsRelatedAppNames = [];
      },
    }
  };
</script>

<style lang="scss" scoped>
.admin-image {
  width: 100%;
  max-width: 100px;
  height: 100%;
  max-height: 100px
}
.image {
  width: 50px;
  height: 50px;
  border-radius:50px;
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}

.member-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-empty {
      display: block;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-location-value {
      width: calc(100% - 12px) !important;
      input {
        border: none !important;
      }
    }
    &-date {
      width: 96%!important;
    }
    &-search {
      float: right;
      margin-right: 10px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
.delete-team-tag-tip-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #e8e8e8;
    .el-dialog__title {
      font-weight: bold;
      font-size: 18px;
    }
  }

  .dialog-content {
    padding: 0 20px;
    
    .section {
      margin-bottom: 24px;
      
      .section-title {
        color: #606266;
        font-size: 16px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        
        i {
          margin-right: 8px;
          font-size: 18px;
        }
      }
      
      .item-list {
        background-color: #f8f9fc;
        border-radius: 4px;
        padding: 12px;
        border-left: 3px solid #e1e6f0;
        
        .item {
          padding: 8px 12px;
          margin: 4px 0;
          background-color: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          
          i {
            margin-right: 8px;
            color: #909399;
          }
        }
      }
    }
  }
}
</style>
